export default __webpack_public_path__ + "static/media/notif_medico_prog.b09fec69.wav";